module.exports = __webpack_public_path__ + "static/media/arrowLogoSvg.083592e9.svg";